import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { IconTypes } from '@shared/v2';

@Component({
  selector: 'sd-cart-list-item-mobile-delete',
  imports: [SdvorIconComponent],
  templateUrl: './cart-list-item-mobile-delete.component.html',
  styleUrls: ['./cart-list-item-mobile-delete.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartListItemMobileDeleteComponent {
  protected removeItem = output<void>();
  protected swipeOffset = input.required<number>();

  protected readonly iconTypes = IconTypes;
}
